import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import PackagingMaterialsTable from '../components/PackagingMaterialsTable';

const PackagingMaterials = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isMaterialsModalOpen, setIsMaterialsModalOpen] = useState(false);
  const [materialsImages, setMaterialsImages] = useState([]);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.PACKAGING_MATERIAL}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_BAG,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsMaterialsModalOpen(true);
              setMaterialsImages([]);
            }}
          >
            Add New Packaging Material
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_BAG,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsMaterialsModalOpen(true);
              setMaterialsImages([]);
            }}
          >
            Add New Packaging Material
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <PackagingMaterialsTable
          isMaterialsModalOpen={isMaterialsModalOpen}
          setIsMaterialsModalOpen={setIsMaterialsModalOpen}
          materialsImages={materialsImages}
          setMaterialsImages={setMaterialsImages}
        />
      </Card>
    </>
  );
};

export default PackagingMaterials;
